import type { LearningAttempt, SkillProgress } from '../models/learning.models';

export interface DescriptiveProgressDescriptor {
  skillId: string;
  label: string;
}

export interface DescriptiveProgressRow extends SkillProgress {
  skillId: string;
  label: string;
}

export function buildProgressBySkill(
  attempts: readonly Pick<LearningAttempt, 'profileId' | 'skillId' | 'correct'>[],
  profileId: string
): Record<string, SkillProgress> {
  const progressBySkill: Record<string, SkillProgress> = {};

  for (const attempt of attempts) {
    if (attempt.profileId !== profileId) {
      continue;
    }
    const progress = progressBySkill[attempt.skillId] ?? { attempts: 0, correct: 0 };
    progressBySkill[attempt.skillId] = {
      attempts: progress.attempts + 1,
      correct: progress.correct + (attempt.correct ? 1 : 0)
    };
  }

  return progressBySkill;
}

export function buildDescriptiveProgressRows(
  descriptors: readonly DescriptiveProgressDescriptor[],
  progressBySkill: Readonly<Record<string, SkillProgress | undefined>>
): DescriptiveProgressRow[] {
  const seen = new Set<string>();
  const rows: DescriptiveProgressRow[] = [];

  for (const descriptor of descriptors) {
    if (seen.has(descriptor.skillId)) {
      continue;
    }
    seen.add(descriptor.skillId);
    const progress = progressBySkill[descriptor.skillId] ?? { attempts: 0, correct: 0 };
    rows.push({
      skillId: descriptor.skillId,
      label: descriptor.label,
      attempts: progress.attempts,
      correct: progress.correct
    });
  }

  return rows;
}
